// Ported 1:1 from the Webflow page markup (scraped/). Class names and data-w-id
// attributes must stay intact: webflow.css and the IX2/Lottie runtime key off them.
import { site } from "@/content/site";
import { useCurrent } from "@/lib/webflow";

export default function Footer() {
  const cur = useCurrent();
  return (
    <section className="section-footer">
      <div className="content">
        <div className="w-layout-grid grid-footer">
          <div id="w-node-d0458a27-e73f-e612-462d-65302581b228-2581b225" className="block-footer">
            <img src="/assets/cdn/655ccb07963af7dd90c4154e_Abilitics%20Logo.svg" loading="eager" alt="Abilitics" className="logo-footer" />
            <div className="paragraph-footer">
              Ability to create success -
              <br />
              you deserve it
              <br />
            </div>
          </div>
          <div id="w-node-d0458a27-e73f-e612-462d-65302581b234-2581b225" className="block-footer">
            <div className="subtitle-footer">
              Quick Links
              <br />
            </div>
            <a href="/" className={cur("/", "link-footer")}>Home</a>
            <a href="/for-founders" className={cur("/for-founders", "link-footer")}>For Founders</a>
            <a href="/ventures" className={cur("/ventures", "link-footer")}>Ventures</a>
            <a href="/blog" className={cur("/blog", "link-footer")}>Blog</a>
            <a href="/about-us" className={cur("/about-us", "link-footer")}>About us</a>
            <a href="https://abilitics.skillie.ai" target="_blank" className="link-footer">Careers</a>
            <a href="/contact" className={cur("/contact", "link-footer")}>Contact</a>
            <a href="/privacy-policy" className={cur("/privacy-policy", "link-footer")}>Privacy Policy</a>
          </div>
          <div id="w-node-d0458a27-e73f-e612-462d-65302581b24c-2581b225" className="block-footer">
            <div className="subtitle-footer">
              Ventures
              <br />
            </div>
            <a href="https://skillie.ai" target="_blank" className="link-footer">Skillie.ai</a>
            <a href="https://www.immersica.io/" target="_blank" className="link-footer">Immersica</a>
            <a href="https://www.vrexpress.io/" target="_blank" className="link-footer">VR&nbsp;Express</a>
            <a href="https://relinkd.net/" target="_blank" className="link-footer">Relinkd.net</a>
            <a href="https://vibejobs.net/" target="_blank" className="link-footer">Vibejobs.net</a>
            <a href="https://www.kognify.ai/" target="_blank" className="link-footer">Kognify.ai</a>
          </div>
          <div id="w-node-d0458a27-e73f-e612-462d-65302581b240-2581b225" className="block-footer">
            <div className="subtitle-footer">
              Social
              <br />
            </div>
            <a href="https://www.facebook.com/abilitics" target="_blank" className="link-footer">Facebook</a>
            <a href="https://linkedin.com/company/abilitics" target="_blank" className="link-footer">LinkedIn</a>
          </div>
        </div>
        <div className="block-footer-down">
          <div className="text-footer-down">
            © {new Date().getFullYear()} {site.name}. All rights reserved.
            <br />
          </div>
        </div>
      </div>
    </section>
  );
}
